import React, { useEffect, useRef, useState } from "react";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Alert, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import { userSendOTP, userSignIn } from "../appRedux/actions";
import IntlMessages from "util/IntlMessages";
import InfoView from "components/InfoView";
import { baseRequest, client } from "../util/Api";

export default function TwoFa(props) {
  const dispatch = useDispatch();
  const authUser = useSelector(({ auth }) => auth.authUser);
  const [image, setImage] = useState(null)
  const [showSecret, setShowSecret] = useState(false)
  const [otp, setOtp] = useState(null)

  function login() {
    dispatch(userSendOTP({ otp: otp }));
  }

  useEffect(async () => {
    if (!authUser) return
    if (!authUser.twofa_required)
      props.history.push("/dashboard");
  }, [authUser])

  useEffect(async () => {
    if (!showSecret) return
    const { qr } = await baseRequest("get", `auth/2fa-secret`);
    setImage(qr)
  }, [showSecret])

  useEffect(async () => {
    const data = await baseRequest("get", "auth/me");
    setShowSecret(!data.has_2fa_secret)
  }, [])

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img alt="example" src="bg.jpg" />
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="2FA" />
              </h1>
              <p>
                <IntlMessages id="Silahkan lakukan autentikasi dua faktor" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img
                alt="example"
                src="/assets/images/logo-idn.png"
                width="150"
              />
            </div>
          </div>
          <div className="gx-app-login-content" style={{
            height: '34rem',
            display: 'flex',
            alignItems: 'center',
          }}>
            {showSecret ? <>
              <Space
                direction="vertical"
                align="center"
                style={{
                  display: 'flex',
                }}
              >
                <Space>
                  <span>
                    Silahkan pindai qrcode dibawah ini menggunakan aplikasi <b>Microsoft Authenticator</b>.
                    Aplikasi dapat diunduh melalui
                    &nbsp;<a target="_blank" href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=id">PlayStore</a>
                    &nbsp;dan&nbsp;
                    <a target="_blank" href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458">App Store</a>.
                    Setelah berhasil dipindai, tekan tombol <b>Masukkan OTP</b>.
                    Jika ada kendala, silahkan hubungi admin melalui whatsapp <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20pendaftaran" target="_blank">081908191001</a>
                  </span>
                </Space>
                <img src={`data:image/png;base64,${image}`} />
                <Button type="primary" className="gx-mb-0"
                  onClick={() => setShowSecret(false)}
                >
                  Masukkan OTP
                </Button>
              </Space>
            </> : <>
              <Space
                direction="vertical"
                align="center"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <h4>OTP</h4>
                <Space>
                  <span>
                    Silahkan buka aplikasi <b>Microsoft Authenticator</b> untuk mendapatkan kode OTP.
                    Jika ada kendala, silahkan hubungi admin melalui whatsapp <a href="https://wa.me/6281908191001?text=Saya%20ada%20kendala%20pendaftaran" target="_blank">081908191001</a>
                  </span>
                </Space>
                <Input
                  placeholder="Masukkan OTP"
                  style={{ textAlign: "center" }}
                  onChange={(e) => setOtp(e.currentTarget.value)}
                />
                <Button type="primary" className="gx-mb-0" onClick={login}>
                  Login
                </Button>
                {/* <Link onClick={() => setShowSecret(true)}>
                  Registrasi Perangkat
                </Link> */}
              </Space>
            </>}
          </div>
          <InfoView />
        </div>
      </div>
    </div>
  );
}